import { stateT } from "../types";
import { ITokenResponseData, IUserDetailResponseData } from "./userTypes";

export const getAuthenticated =
  () =>
  ({ ...state }: stateT) => {
    const isAuthenticated: boolean = state.user.isAuthenticated;
    return isAuthenticated;
  };

export const getToken =
  () =>
  ({ ...state }: stateT) => {
    const token: ITokenResponseData = state.user.token;
    return token;
  };

export const getUser =
  () =>
  ({ ...state }: stateT) => {
    const user: IUserDetailResponseData = state.user.user;
    return user;
  };
